import { useAuthStore } from "../stores/authStore";

export function getEnteredByUser() {
  const state = useAuthStore.getState();
  return state.user?.username || state.user?.displayName || "system";
}

